export type CheckImageWidgetPageState =
  (typeof checkImageWidgetPageStateMapping)[keyof typeof checkImageWidgetPageStateMapping];

export const checkImageWidgetPageStateMapping = {
  Idle: 0,
  Analyzing: 1,
  Widgeting: 2,
  Completing: 3,
  Viewing: 4,
  Error: 5,
} as const;
